import { createBookmark } from '@/lib/server-functions/create-bookmark';
import { QUERY_KEYS } from '@/lib/tanstack-query/queryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type NewBookmark = {
  pollId: string;
};

export const useCreateBookmark = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: NewBookmark) => {
      await createBookmark({ data: payload });
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.BOOKMARKS],
      });
    },
  });
};
